import React, { useState, useEffect } from "react";
import { KTSVG } from "../../../../_metronic/helpers";
import { ListGrid } from "./ListGrid";
import { Link } from "react-router-dom";
import { Filter } from "./Filter";
import { CardList } from "./CardList";
import { getAllCollaborators } from "app/service/collaborator/Collaborator";
import { Collaborator } from "app/types/collaborator";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_NET;

const View: React.FC = () => {
  const [section, setSection] = useState<string | "BOARD" | "LIST">(localStorage.getItem("viewMode") ?? 'LIST');
  const [loadingGrid, setLoadingGrid] = useState(true);
  const [initFilterValues, setInitFilterValues] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [collaborators, setCollaborators] = useState<Collaborator[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(section === 'BOARD' ? 9 : 10);

  const onSearchFilter = (values: any) => {
    setLoadingGrid(true);
    setInitFilterValues(values ?? {});
  };

  const onCleanFilter = () => {
    setLoadingGrid(true);
    setInitFilterValues({});
  };

  const toggleMode = (mode: "LIST" | "BOARD") => {
    localStorage.setItem("viewMode", mode);
    setSection(mode);
  };
  const getDataAsync = async () => {
    const resCollaborators = await getAllCollaborators(currentPage, pageSize, initFilterValues);
    setCollaborators(await Promise.all(resCollaborators.records.map(async (record) => ({
      ...record,
      perfil: record.employe?.profile ?? "No registrado",
      departamento: record.employe?.department ?? "No registrado",
      photo: await axios
        .post(`${API_URL}Collaborator/${record.id}/image-profile-view`)
        .then((res) => res.data)
        .catch(() => null)
    }))));
    setTotalRecords(resCollaborators.totalRecords);
    setLoadingGrid(false);
  };

  useEffect(() => {
    getDataAsync();
  }, [currentPage, pageSize, initFilterValues])

  useEffect(() => {
    setPageSize(section === 'BOARD' ? 9 : 10);
  }, [section])
  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xxl-12 col-xl-12 col-md-12 col-lg-12">
          <div className="card card-flush p-5">
            <div className="row">
              <div className="col-xxl-8 col-xl-8 col-md-8 col-lg-8">
                <ul className="nav nav-line-tabs nav-line-tabs-2x border-transparent fs-7 fw-bolder flex-nowrap">
                  <li className="nav-item cursor-pointer ">
                    <a
                      className={`nav-link me-6 ${section === "LIST" ? "text-active-primary active" : ""
                        } `}
                      onClick={() => toggleMode("LIST")}
                    >
                      <KTSVG
                        path="/media/icons/duotune/text/txt001.svg"
                        className="svg-icon-1 fs-7"
                      />
                      <span className="margin-left-05">Lista</span>
                    </a>
                  </li>
                  <li className="nav-item cursor-pointer">
                    <a
                      className={`nav-link me-6  ${section === "BOARD" ? "text-active-primary active" : ""
                        }`}
                      onClick={() => toggleMode("BOARD")}
                    >
                      <KTSVG
                        path="/media/icons/duotune/layouts/lay002.svg"
                        className="svg-icon-1 fs-7"
                      />
                      <span className="margin-left-05">Tarjetas</span>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4 position-end">
                <div className="card-title center-items">
                  <Link
                    className="btn btn-sm btn-icon btn-light-primary border-btn"
                    to={"/recursos_humanos/colaboradores/add"}
                  >
                    <KTSVG
                      path="/media/icons/duotune/abstract/abs011.svg"
                      className="svg-icon-5 svg-icon-gray-500 "
                    />
                  </Link>
                </div>

                <div className="mr-05"></div>
                <Filter
                  initFilterValues={initFilterValues}
                  onCleanFilter={onCleanFilter}
                  onSearchFilter={onSearchFilter}
                />
              </div>
            </div>
            <div className="row">
              {section === "BOARD" ? (
                <CardList
                  board={collaborators}
                  totalRecords={totalRecords}
                  pageSize={pageSize}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              ) : null}
              {section === "LIST" ? (
                <ListGrid
                  data={collaborators}
                  loadingGrid={loadingGrid}
                  totalRecords={totalRecords}
                  pageSize={pageSize}
                  page={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { View };
